import { Component, OnInit } from '@angular/core';
import { PopupModalComponent } from '../shared/popup-modal/popup-modal.component';
import { RestService } from 'src/app/services/rest.service';
import { GuiService } from 'src/app/services/gui.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'vex-user-addons',
  templateUrl: './user-addons.component.html',
  styleUrls: ['./user-addons.component.scss']
})
export class UserAddonsComponent implements OnInit {
  addons: any = [];
  totalAmount: any = 0;
  pageSpinner: boolean = true;
  addonCategory!: string | null;
  addonTags!: string | null;
  purchaseSpinner: boolean = false;

  constructor(private restService: RestService, public guiService: GuiService, public translate: TranslateService, public dialog: MatDialog) { }

  ngOnInit() {
    this.guiService.showSpinner = false;
    if (this.guiService.userLogged) {
      this.addonCategory = sessionStorage.getItem('addonCategory') ? sessionStorage.getItem('addonCategory') : null;
      this.addonTags = sessionStorage.getItem('addonTags') ? JSON.parse(sessionStorage.getItem('addonTags')) : null;
      this.getAddons();
    } else {
      this.guiService.goTo('main/home');
    }
  }

  getAddons() {
    const param: any = {
      userId: this.guiService.userLogged.user.id,
    };
    if (this.addonCategory) {
      param.category = this.addonCategory;
    }
    if (this.addonTags) {
      param.tags = this.addonTags;
    }

    this.pageSpinner = true;

    this.restService.postService('node', '/user-addons', param).subscribe((ris) => {
      console.debug(ris);
      this.totalAmount = 0;
      this.addons = ris.items;
      this.addons.forEach(addon => {
        addon.quantity.count = 0;
      });
      this.guiService.showSpinner = false;
      if (this.addons.length === 1) {
        const addon = this.addons[0];
        addon.isSingleItem = true;
        this.addonDetail(addon);
      }
      this.pageSpinner = false;
    })
  }

  addQuantity(addon: any, sign: string) {
    const price = parseFloat(addon.price);
    if (sign === 'plus' && addon.quantity.count < addon.quantity.max) {
      addon.quantity.count++;
      this.totalAmount = Number((this.totalAmount + price).toFixed(2));
    } else if (sign === 'minus' && addon.quantity.count >= addon.quantity.min) {
      addon.quantity.count--;
      this.totalAmount = Number((this.totalAmount - price).toFixed(2));
    }
  }

  addonDetail(item: any) {
    const addon = JSON.stringify(item);
    sessionStorage.setItem('addonDetail', addon);
    this.guiService.goTo('main/addon-detail');
  }

  getItemPriceIds(){
    return this.addons
    .filter(a => a.quantity.count > 0)
    .map(a => ({
      item_price_id: a.itemPriceId,
      quantity: a.quantity.count
    }));
  }

  getItemUl(){
    return this.addons
    .filter(a => a.quantity.count > 0)
    .map(a => ({
      i18nName: a.i18nName,
      quantity: a.quantity.count,
      currency: a.currency,
      totalPriceLine: (a.price * a.quantity.count).toFixed(2)
    }));
  }

async openModalConfirmPurchase() {
  const items = this.getItemUl();

  const liList = items.map(it => {
    const name = it.i18nName?.[this.translate.currentLang.toUpperCase()] ?? '';
    const price = it.totalPriceLine + it.currency;
    return `<li>${name} (${this.translate.instant('ADDONS.QTY')}:${it.quantity}) - <span class="violet">${price}</span></li>`;
  }).join('');

  const html = `${this.translate.instant('ADDONS.POPUP_MSG_1')} <br> <ul>${liList}</ul> <br> ${this.translate.instant('ADDONS.POPUP_MSG_2', { totalAmount: this.totalAmount.toFixed(2) + "$" })}`;

  const dialogRef = this.dialog.open(PopupModalComponent, {
    panelClass: 'purchase-addon-modal',
    disableClose: true,
    data: {
      title: this.translate.instant('ADDONS.BUY_2'),
      subTitle: '',
      customHtml: html,
      buttonTitle: this.translate.instant("HOME.MODAL-MARK.BTN-CONFIRM"),
      closeBtnTop: true,
      callbackBtn: 'buy'
    }
  });

  dialogRef.afterClosed().subscribe((dataReturned) => {
    if (dataReturned?.callback === 'buy') {
      this.purchaseSpinner = true;
      const body: any = {
        userId: this.guiService.userLogged.user.id,
        customerId: this.guiService.userLogged.userPaymentInfo.chargebeePaymentInfo.customerId,
        customerEmail: this.guiService.userLogged.user.email,
        itemPriceIds: this.getItemPriceIds()
      };

      this.restService.postService('node', '/purchase-addon', body).subscribe((ris) => {
        this.purchaseSpinner = false;
        this.openModalPaymentResult(ris.success);
      });
    }
  });
}


openModalPaymentResult(status: boolean): void {
  const dialogRef = this.dialog.open(PopupModalComponent, {
    panelClass: 'custom-modal',
    disableClose: true,
    data: {
      icon: status ? 'checkmark-outline' : 'close-outline',
      iconClass: status ? 'green' : 'red',
      title: status ? this.translate.instant("ADDONS.PAYMENT_DONE_TITLE") : this.translate.instant("ADDONS.PAYMENT_FAILED_TITLE"),
      subTitle: status ? this.translate.instant("ADDONS.PAYMENT_DONE_MSG") : this.translate.instant("ADDONS.PAYMENT_FAILED_MSG"),
      redirectUrl: 'main/tabs/home',
      buttonTitle: status ? "Ok" : this.translate.instant("ADDONS.BACK")
    }
  });
}

}
